<div class="loader" [class.vertical]="!horizontal">
  <div class="loader-ring">
    <i2g-icon class="spinner" [icon]="spinnerIcon"> </i2g-icon>
  </div>

  <h3 *ngIf="loaderText" class="loader-text">
    {{ loaderText }}
  </h3>
</div>
